/* eslint-disable no-plusplus */
/**
 * Created by ivancai on 2019/5/13.
 * 此工具类请放置一些常用操作函数，如字符操作，存取cookie等
 */
import axios from 'axios';
import baseUrl from '@/configs/baseUrl';
import moment from 'moment';

export default {
	getCookie(cname) {
		const name = `${cname}=`;
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			const c = ca[i].trim();
			if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
		}
		return '';
	},
	getQueryString(name) {
		const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
		const r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	},
	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		const expires = `expires=${d.toGMTString()}`;
		document.cookie = `${cname}=${cvalue}; ${expires}`;
	},
	blobLoadDownLoad(data, fileName) {
		let blob = new Blob([data], {
			type: "application/vnd.ms-excel"
		});
		// FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
		const fileReader = new FileReader();
		// 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
		fileReader.readAsDataURL(blob);
		fileReader.onload = (event) => {
			// 处理load事件。该事件在读取操作完成时触发
			// 新建个下载的a标签，完成后移除。
			//创建一个a标签
			let a = document.createElement("a");
			//表格名称
			let _fileName = fileName;
			a.download = _fileName;
			a.href = event.target.result;
			document.body.appendChild(a);
			//模拟a标签点击事件
			a.click();
			document.body.removeChild(a);
		}
	},
	downloadFile(url, params = {}, withToken = true, needBaseUrl = true) {
		const token = this.getCookie('authorization');
		const headers = withToken ? {
			'authorization': 'Bearer' + ' ' + token
		} : {};
		url = needBaseUrl ? `${baseUrl}${url}` : url;
		return axios({
			url,
			method: 'GET',
			params,
			responseType: 'blob',
			headers
		});
	},
	downloadBlobFile(blob, filename) {
		const objUrl = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		if ('download' in a) {
			document.body.appendChild(a);
			a.style.display = 'none';
			a.href = objUrl;
			a.download = filename;
			a.click();
			window.URL.revokeObjectURL(objUrl);
			document.body.removeChild(a);
			return;
		}
		// IE
		navigator.msSaveBlob(blob, filename);
	},
	base64ToBlob(dataurl) {

		const arr = dataurl.split(',');
		const mime = arr[0].match(/:(.*?);/)[1];
		const bstr = atob(arr[1]);
		let n = bstr.length;
		const u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], {
			type: mime
		});
	},
	blobToDataURL(blob, callback) {
		var a = new FileReader();
		a.onload = function(e) {
			callback(e.target.result);
		};
		a.readAsDataURL(blob);
	},
	getBeforeDate(num, time) {
		let n = num;
		let d = '';
		if (time) {
			d = new Date(time);
		} else {
			d = new Date();
		}
		let year = d.getFullYear();
		let mon = d.getMonth() + 1;
		let day = d.getDate();
		if (day <= n) {
			if (mon > 1) {
				mon = mon - 1;
			} else {
				year = year - 1;
				mon = 12;
			}
		}
		d.setDate(d.getDate() - n);
		console.log(d.getDate())
		year = d.getFullYear();
		mon = d.getMonth() + 1;
		day = d.getDate();
		let s = (mon < 10 ? ('0' + mon) : mon) + "." + (day < 10 ? ('0' + day) : day);
		return s;
	},
	onChange_checkbox(startDateEnd, startDateBegin) {
		// console.log('开始日期：' + moment(this.queryParam.startDateBegin)) //2020-07-01
		// console.log('开始日期：' + moment(this.queryParam.startDateBegin).add(1, 'days')) //2020-07-01
		// let new_time = moment(this.queryParam.startDateBegin)
		//   .add(1, 'days')
		//   .format('YYYY-MM-Ddd')
		// console.log(new_time)

		if (startDateEnd != null && startDateBegin != null) {
			//清空数组
			var checkBoxList = []
			// 转换日期格式 并循环遍历日期 
			let beginDate = moment(startDateBegin)
			let endDate = moment(startDateEnd)
			for (beginDate; beginDate <= endDate;) {
				var time = beginDate.format('MM.DD')
				checkBoxList.push(time)
				beginDate.add(1, 'days')
			}
			console.log(checkBoxList)
			return checkBoxList;
		}
	},

};

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}
